const constants = {
    copyright_time: '2022',
    site_name: '立哲信息服务网',
    icp: '鲁ICP备2022033477号',

    main_color: '#ff451c',

    site: '33fanli',
    domain: '33fanli.top',
    url: 'https://www.33fanli.top',

    rsa_pkcs1_publickey: `-----BEGIN PUBLIC KEY-----
    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCk/rMfFKtQW51ST8v/nXjgR876
    w7Vq/+8S9fE7MJPovL8QeqOLnVLNr+ERTCAuq8KF/E5DTcGW4e1NRLN8Jvo2ccKo
    pNOh4x8OxzEKofhc/jHnJR/wljyb4uoIOU+5YRc49bBsOTNfiIaMh/QbrK/YpuAu
    wAFjjUu5xgug98TwBQIDAQAB
    -----END PUBLIC KEY-----`,

    success : "1",
    fail : "0",
}

export default constants;